<template>
    <div class="Pending">
        <Box title="维修处理">
            <FacilityDetails :data="EquipmentInfo" />
            <!--设备信息-->
            <RepairsDetails :data="RepairInfo" />
            <!--报修信息-->
            <div class="infoBox info">
                <p class="title">报修图片</p>
                <div class='ContentPhoto'>
                    <img v-for="(item,index) in RepairPhotos" :src="item" @click="showImg(index)"/>
                </div>
            </div>
            <!--报修语音-->
            <Audio :AudioExternal='RepairInfo.AudioUrl'/>
            <ServicePerson :data="RY" @OnMessage="value => RY = value" />
            <!--维修人-->
            <Accessories :data="PJ" @OnMessage="value=>PJ=value" />

            <!--配件信息-->
            <div class="infoBox info">
                <p class="title">维修信息</p>
                <Field title="维修日期" placeholder="请选择" type="calendar" :text="WXRQ" @onMessage="value => WXRQ = value" />

                <Field type="manufacturer" name="faultType"
                    @manuconfirm="MaintainSelect('GZLX',arguments[0])"
                    title="故障类型" :action="true" :text="RepairModel.GZLXMC" @input="value=>MaintainSelect('GZLX',{a:null,b:value})"
                    :SelectionAndInput='true' />

                <Field type="manufacturer" name="failureProblem"
                    @manuconfirm="MaintainSelect('GZWT',arguments[0])"
                    title="故障问题" :action="true" :text="RepairModel.GZWTMC" @input="value=>MaintainSelect('GZWT',{a:null,b:value})"
                    :SelectionAndInput='true' />

                <Field type="manufacturer" name="solution"
                    @manuconfirm="RepairModel.JJFABH=arguments[0].a,RepairModel.JJFAMC=arguments[0].b"
                    title="解决方案" :action="true" :text="RepairModel.JJFAMC" @input="value=>{RepairModel.JJFAMC=value;RepairModel.JJFABH=null}"
                    :SelectionAndInput='true' />

                <Field title="维修类型" placeholder="点击选择维修类型" type='popup' :text="RepairTypeName" :data="['自修', '维修合同','质保期内','厂家维修','其他']"
                    @confirm="value => RepairType = value==='自修'?'':value==='维修合同'?'2':
                value==='质保期内'?'3':value==='厂家维修'?'4':'1'" />
                <Field v-if="RepairType!==''" title="维修厂家" name="maintain" :text="RepairFactoryName" @manuconfirm="RepairFactory=arguments[0].a,RepairFactoryName=arguments[0].b"
                    type="manufacturer" placeholder="请选择" />

                <van-cell>
                    <template>
                        <div class="Parts">
                            <span>维修工程师</span>
                            <span class="empty">{{$UserInfo.UserName}}</span>
                        </div>
                    </template>
                </van-cell>

                <Field title="维修工时" :text="WXGS" type="number" name="number" @onMessage="value=>WXGS=value" />
                <Field title="预计维修费用" :text="ExpectMaintainMoney"

                 :type="this.$route.params.SystemValue=='Y'?'text':'number'" name="number" @onMessage="value=>ExpectMaintainMoney=value" />

                <Field title="维修费用" :text="MaintainMoney" type="number" name="number" @onMessage="value=>MaintainMoney=value" />
                <van-cell>
                    <template>
                        <div class="Parts">
                            <span>配件费用</span>
                            <span class="empty">{{AccessoriesMoney?AccessoriesMoney:'选择配件自动计算'}}</span>
                        </div>
                    </template>
                </van-cell>

               <van-cell>
                    <template>
                        <div class="Parts">
                            <span>合计费用</span>
                            <span class="empty">{{TotalMoney?TotalMoney:'自动计算'}}</span>
                        </div>
                    </template>
                </van-cell>

               <!-- <Field title="合计费用" :text="TotalMoney=Number(MaintainMoney)+Number(AccessoriesMoney)" type="text" /> -->


                <Field title="维修结果" :text='RepairMark' placeholder="请输入维修结果!" type="textarea" @onMessage="value=>RepairMark=value" />
                <ImgModule title='维修图片' upload @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" :deletable='true' />
                <!--维修图片-->
                <div style="margin-top: 50px;"></div>
            </div>

        </Box>
        <Footer v-if="!this.$route.params.ButtonExists" @save="save()" @change="change()" :button="[
        {text:'提交维修记录',background:'#4FA69E',color:'#FFFFFF',event:'change'},{text:'保存维修记录',background:'#4FA69E',color:'#FFFFFF',event:'save'}]" />
    </div>
</template>

<script>
    import Audio from '../../components/Audio/AudioDefault.vue'
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import RepairsDetails from '../../components/repairsDetails/repairsDetails'
    import Footer from '../../components/footer/footer'
    import ImgModule from '../../components/imgModule/imgModule'
    import Check from '../../components/check/check'
    import Field from '../../components/field/field'
    import ServicePerson from '../../components/servicePerson/servicePerson'
    import Accessories from '../../components/accessories/accessories'
    import {Cell,ImagePreview} from 'vant'
    export default {
        name: 'Pending',
        components: {
            Audio,
            Box,
            FacilityDetails,
            Footer,
            RepairsDetails,
            ImgModule,
            Check,
            Field,
            ServicePerson,
            Accessories,
            [Cell.name]:Cell,
            [ImagePreview.name]:ImagePreview
        },
        data() {
            return {
                EquipmentInfo: this.$route.params.item,
                RepairInfo: {},
                RY: [],
                PJ: [],
                JC: [],
                ImageArray: this.$route.params.ImageArray || [],
                //进程详情
                ExpectMaintainMoney:this.$route.params.item.ExpectMaintainMoney ? this.$route.params.item.ExpectMaintainMoney :
                    0, //预计维修费用
                MaintainMoney: this.$route.params.ProcessDefault.MaintainMoney ? this.$route.params.ProcessDefault.MaintainMoney :
                    null, //维修费用
                AccessoriesMoney: this.$route.params.ProcessDefault.AccessoriesMoney ? this.$route.params.ProcessDefault
                    .AccessoriesMoney : null, //配件费用
                TotalMoney: this.$route.params.ProcessDefault.TotalMoney ? this.$route.params.ProcessDefault.TotalMoney :
                    0, //合计费用
                RepairFactory: this.$route.params.ProcessDefault.RepairFactory ? this.$route.params.ProcessDefault.RepairFactory :
                    '', //维修厂家
                RepairFactoryName: this.$route.params.ProcessDefault.RepairFactoryName ? this.$route.params.ProcessDefault
                    .RepairFactoryName : '', //维修厂家名称
                RepairType: this.$route.params.ProcessDefault.RepairType ? this.$route.params.ProcessDefault.RepairType :
                    '', //维修类型
                    RepairTypeName:this.$route.params.ProcessDefault.RepairTypeName ? this.$route.params.ProcessDefault.RepairTypeName :
                    '',
                RepairMark: `${this.$route.params.ProcessDefault.RepairMark}\n${this.$format(new Date(),'YYYY-MM-DD hh:mm')} By ${this.$UserInfo.UserName}:`, //维修结果
                WXGS: this.$route.params.ProcessDefault.WXGS ? this.$route.params.ProcessDefault.WXGS : '0', //维修工程师维修工时

                WXRQ: this.$format(new Date(), 'YYYY-MM-DD'),
                RepairModel: {
                    GZLXBH: null,
                    GZLXMC: null,
                    GZWTBH: null,
                    GZWTMC: null,
                    JJFABH: null,
                    JJFAMC: null
                },//维修处理故障情况
                RepairPhotos:[],
            }
        },
        mounted() {
            this.loadDataDefault();
        },
        methods: {
            save() { //保存维修记录
                if (!this.RepairMark) {
                    this.$Toast('请填写维修结果!');
                    this.$scrollscreen('.Pending', 'end');
                    return false;
                }
                for (let i = 0; i < this.RY.length; i++) {
                    if (!this.RY[i].Time) {
                        this.$Toast('请填写' + this.RY[i].b + '的维修工时!(单位:时)');
                        return false;
                    }
                }
                if(this.RepairType==''){
                    this.RepairFactory='';this.RepairFactoryName=''
                }
                this.$post('api/Repair/UploadRepairProcessing', {
                    GKHM: this.$UserInfo.UserId,
                    WXDH: this.EquipmentInfo.RepairOrder,
                    JCHH: '1',
                    YJWXJE:this.ExpectMaintainMoney||0,//预计维修金额
                    WXGS: this.WXGS, //维修工程师维修工时（默认为当前登陆人）
                    WXRQ: this.WXRQ,
                    MaintainMoney: this.MaintainMoney, //维修费用
                    AccessoriesMoney: this.AccessoriesMoney, //配件费用
                    TotalMoney: this.TotalMoney, //总费用（此进程总费用）
                    RepairFactory: this.RepairFactory , //维修厂家（目前数据库存放name，未知错误）
                    RepairFactoryName: this.RepairFactoryName, //维修厂家（目前数据库存放name，未知错误）
                    RepairType: this.RepairType,
                    RepairMark: this.RepairMark, //维修结果
                    serviceman: this.RY,
                    accessories: this.PJ,
                    GZLXBH:this.RepairModel.GZLXBH,
                     GZLXMC:this.RepairModel.GZLXMC,
                    GZWTBH:this.RepairModel.GZWTBH,
                    GZWTMC:this.RepairModel.GZWTMC,
                    JJFABH:this.RepairModel.JJFABH,
                    JJFAMC:this.RepairModel.JJFAMC
                }).then(result => {
                     this.$Toast(result.Status?'保存成功!':'保存失败,请联系管理员!');
                })
            },
            change() { //维修处理提交
                this.$Dialog.confirm({
                    message: '确定提交维修处理记录?'
                }).then(() => {
                    this.$get('api/Repair/SubmitRepairProcessing', {
                        WXDH: this.EquipmentInfo.RepairOrder,
                        JCHH: '1',
                        GKHM: this.$UserInfo.UserId,
                        SBBH: this.EquipmentInfo.EquCode,
                        KS: this.$UserInfo.DepartmentId,
                        STORE: this.$UserInfo.StoreCode,
                        TotalMoney: this.TotalMoney
                    }).then(result => {
                        this.$Toast(result.Msg);
                        if (result.Status) {
                            this.$Bus.$emit('Message', this.EquipmentInfo.RepairOrder);
                            setTimeout(X => {
                                this.$router.back();
                            }, 2000);
                        }
                    })
                }).catch(() => {})
            },
            afterRead(object) {
                let baseList = [];
                if (object instanceof Array) {
                    object.forEach(function(item, index) {
                        baseList.push(item.content);
                    })
                } else baseList.push(object.content);
                this.$post('api/Repair/RepairProcessingToUpload', {
                    WXDH: this.EquipmentInfo.RepairOrder,
                    JCHH: '1',
                    GKHM: this.$UserInfo.UserId,
                    baseList: baseList
                }, 20000).then(result => {
                    if (result.Staus) {
                        this.$Toast('上传成功!');
                    } else this.$Toast(result.Msg);
                })
            },
            deleteImg(object) { //图片删除
                this.$Dialog.confirm({
                    message: '确定删除?'
                }).then(() => {
                    this.$get('api/Repair/DeleteImgForRepairProcessing', {
                        WXDH: this.EquipmentInfo.RepairOrder,
                        HH: object.HH,
                        Repath: object.Repath
                    }).then(result => {
                        if (result.Status) {
                            this.ImageArray.splice(this.ImageArray.findIndex(x => x.HH === object.HH),
                                1);
                            this.$Bus.$emit('YSRKDelete', this.ImageArray);
                            this.$Toast('删除成功!');
                        } else this.$Toast('删除失败!');
                    })
                }).catch(() => {})
            },
            loadDataDefault() { //获取维修信息
                this.$get('/api/Repair/GetRepairInfo', {
                    RepairNo: this.EquipmentInfo.RepairOrder,
                    Store: this.$UserInfo.StoreCode,
                    Token: '1235'
                }).then(result => {
                    this.RepairModel.GZLXBH=result.RepairInfo.GZLXBH;
                    this.RepairModel.GZLXMC=result.RepairInfo.GZLXMC;
                    this.RepairModel.GZWTBH=result.RepairInfo.GZWTBH;
                    this.RepairModel.GZWTMC=result.RepairInfo.GZWTMC;
                    this.RepairModel.JJFABH=result.RepairInfo.JJFABH;
                    this.RepairModel.JJFAMC=result.RepairInfo.JJFAMC;
                    this.RepairInfo = result.RepairInfo;

                    var that=this;
                    var ImgData=result.RepairInfo.Images.split(',');
                    ImgData.forEach(function(item,index){
                        item?that.RepairPhotos.push(item):'';
                    })
                })
            },
            MaintainSelect(type, data) {
                if (type === 'GZLX') {
                    this.RepairModel.GZLXBH = data.a;
                    this.RepairModel.GZLXMC = data.b;
                    this.RepairModel.GZWTBH = null;
                    this.RepairModel.GZWTMC = null;
                } else if (type === 'GZWT') {
                    this.RepairModel.GZWTBH = data.a;
                    this.RepairModel.GZWTMC = data.b;
                    this.RepairModel.JJFABH = null;
                    this.RepairModel.JJFAMC = null;
                }
                this.$Bus.$emit('RepairSelect', {
                    MaintainSelectIndex: data.a,
                    MaintainSelectType: type
                });
            },showImg(index) {
                ImagePreview({
                    images: this.RepairPhotos,
                    startPosition: index,
                    swipeDuration: 500,
                    closeOnPopstate: true,
                })
            }
        },
        watch: {
            PJ(object) { //监听配件，加载配件金额
                let that = this;
                that.AccessoriesMoney = 0;
                object.forEach(function(item, index) {
                    that.AccessoriesMoney += item.DJ * item.SYSL;
                })
            },MaintainMoney(newvalue,oldvalue){//维修费用
                this.TotalMoney=Number(this.AccessoriesMoney)+Number(newvalue);
            },AccessoriesMoney(newvalue,oldvalue){//配件费用
                this.TotalMoney=Number(this.MaintainMoney)+Number(newvalue);
            }
        }
    }
</script>

<style scoped lang="scss">
    .record {
        p:last-child {
            font-size: 28px;
            color: #858585;
        }
    }

    .receiveBox {
        border-bottom: 2px solid #F3F3F3;

        .receiveItems {
            display: flex;
            margin-bottom: 38px;

            &>span {
                color: #858585;
                font-size: 28px;
                margin-right: 32px;
            }
        }
    }

    .repairTitle {
        font-size: 28px;
        color: $TEXT-DARK-COLOR;
        margin-top: 30px;
    }

    .repairBox {
        display: flex;
        margin-top: 28px;
        padding-bottom: 30px;
        border-bottom: 2px solid #F3F3F3;

        div {
            width: 148px;
            height: 76px;
            border-radius: 8px;
            background: #f3f3f3;
            color: #858585;
            line-height: 76px;
            text-align: center;
            font-size: 30px;
            margin-right: 24px;
        }

        .action {
            background: $THEME-COLOR;
            color: #fff;
        }
    }

    .receive {
        padding-bottom: 0;
    }

    .empty {
        color: #858585;
    }

    .real {
        color: #14171a;
    }

    .Parts{
        font-size: 4vw;
        height: 14.933vw;
        display: flex;
        align-items: center;
        &>span{
            &:first-child{
                float:left;
                width: 50%;
            }
            &:last-child{
                 text-align: right;
                 width: 50%;
            }
        }

    }
    .van-cell{
        padding: 0 !important;
    }

    textarea {
        font-size: 30px;
        width: 100%;
        border: none;
        resize: none;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }
    .ContentPhoto {
        img{
            width: 106px;
            height: 106px;
            margin: 0 10px;
        }
    }
    .imgModuleBox{
        padding: 0 !important;
    }
</style>



// WEBPACK FOOTER //
// src/page/pending/pending.vue